import { BehaviorSubject }	from 'rxjs';
import { Component }				from '@angular/core';
import {
	AppState,
	ConfigService,
	StateService
}														from '../../';

@Component({
  selector: 		'electra-root',
  styleUrls: 		[ './electra.component.scss' ],
  templateUrl: 	'./electra.component.html'
})
export class ElectraComponent {
	menuState = '';

  get menuClass(): string {
    return this.configService.desktopClass + ' ' + this.configService.showMenuClass;
  }

	constructor(public configService: ConfigService, public stateService: StateService) {
		stateService.app.subscribe(data => { this.gotState(data); });
    
    console.log('Electra component created');
	}

	gotState(state: AppState) {
		if (this.configService.mobile) {
			if (state.filter || state.legend) {
				this.menuState = 'partial';
			} else if (state.iab || state.more || state.about || state.terms) {
				this.menuState = 'full';
			} else {
				this.menuState = '';
			}
		} else {
			if (state.about || state.terms) {
				this.menuState = 'full';
			} else if (state.iab || state.more || state.filter || state.legend) {
				this.menuState = 'partial';
			} else {
				this.menuState = '';
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/electraLib/component/electra/electra.component.ts